import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";
import { MemoryMessage } from "../hooks/useMemoryMessages";

interface MemoryCardProps {
  msg: MemoryMessage;
  isLast: boolean;
}

export function MemoryCard({ msg, isLast }: MemoryCardProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const displayContent = msg.content;

  const formatDate = (d: string) =>
    new Date(d).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Box>
      <Paper
        sx={{
          borderRadius: 2,
          p: 2,
          boxShadow: 0,
          bgcolor: colors.primary[900],
          border: "1px solid #f1f5f9",
        }}
      >
        <Typography
          sx={{ fontSize: "13px", color: "#475569", lineHeight: 1.6, mb: 1.5 }}
        >
          {displayContent}
        </Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
            {msg.approved_by_username ? (
              <>
                Approved by{" "}
                <Box
                  component="span"
                  sx={{ fontWeight: 700, color: "#475569" }}
                >
                  {msg.approved_by_username}
                </Box>
              </>
            ) : (
              <Box component="span" sx={{ color: "#cbd5e1" }}>
                Not yet approved
              </Box>
            )}
          </Typography>
          <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
            {formatDate(msg.created_at)}
          </Typography>
        </Stack>
      </Paper>

      {!isLast && (
        <Box sx={{ width: 2, height: 16, bgcolor: "action.hover", mx: "auto" }} />
      )}
    </Box>
  );
}
